import { generateMongoId } from "src/helpers/helperFunctions";
import { IDoctorProfile, ListType } from "src/types/GlobalInterfaces";

export const categoryList: ListType[] = [
  {
    label: "Beauty Care",
    value: "beauty-care",
    id: generateMongoId(),
    subCategories: [
      {
        label: "Dermocosmetics",
        value: "dermocosmetics",
        id: generateMongoId(),
        childCategories: [
          {
            label: "Facial Wash/Cleanser",
            value: "facial-wash-cleanser",
            id: generateMongoId(),
          },
          {
            label: "Makeup Remover",
            value: "makeup-remover",
            id: generateMongoId(),
          },
          { label: "Eye Cream", value: "eye-cream", id: generateMongoId() },
          { label: "Face Toner", value: "face-toner", id: generateMongoId() },
        ],
      },
      {
        label: "Skincare Essentials",
        value: "skincare-essentials",
        id: generateMongoId(),
        childCategories: [
          {
            label: "Moisturizing Lotion",
            value: "moisturizing-lotion",
            id: generateMongoId(),
          },
          { label: "Serum", value: "serum", id: generateMongoId() },
          { label: "Night Cream", value: "night-cream", id: generateMongoId() },
        ],
      },
      {
        label: "Anti-Aging",
        value: "anti-aging",
        id: generateMongoId(),
        childCategories: [
          {
            label: "Wrinkle Cream",
            value: "wrinkle-cream",
            id: generateMongoId(),
          },
          {
            label: "Retinol Serum",
            value: "retinol-serum",
            id: generateMongoId(),
          },
          {
            label: "Eye Lift Gel",
            value: "eye-lift-gel",
            id: generateMongoId(),
          },
        ],
      },
    ],
  },
  {
    label: "Hair Care",
    value: "hair-care",
    id: generateMongoId(),
    subCategories: [
      {
        label: "Shampoo & Conditioner",
        value: "shampoo-conditioner",
        id: generateMongoId(),
        childCategories: [
          {
            label: "Hydrating Shampoo",
            value: "hydrating-shampoo",
            id: generateMongoId(),
          },
          {
            label: "Repair Conditioner",
            value: "repair-conditioner",
            id: generateMongoId(),
          },
          {
            label: "Volumizing Shampoo",
            value: "volumizing-shampoo",
            id: generateMongoId(),
          },
          {
            label: "Anti-Dandruff",
            value: "anti-dandruff",
            id: generateMongoId(),
          },
        ],
      },
      {
        label: "Hair Treatments",
        value: "hair-treatments",
        id: generateMongoId(),
        childCategories: [
          { label: "Hair Mask", value: "hair-mask", id: generateMongoId() },
          {
            label: "Oil Treatment",
            value: "oil-treatment",
            id: generateMongoId(),
          },
          { label: "Scalp Serum", value: "scalp-serum", id: generateMongoId() },
        ],
      },
      {
        label: "Styling Products",
        value: "styling-products",
        id: generateMongoId(),
        childCategories: [
          { label: "Hair Gel", value: "hair-gel", id: generateMongoId() },
          { label: "Hairspray", value: "hairspray", id: generateMongoId() },
          { label: "Wax", value: "wax", id: generateMongoId() },
        ],
      },
    ],
  },
  {
    label: "Sun Care",
    value: "sun-care",
    id: generateMongoId(),
    subCategories: [
      {
        label: "Sunscreen",
        value: "sunscreen",
        id: generateMongoId(),
        childCategories: [
          {
            label: "SPF 30 Lotion",
            value: "spf-30-lotion",
            id: generateMongoId(),
          },
          {
            label: "SPF 50 Cream",
            value: "spf-50-cream",
            id: generateMongoId(),
          },
          {
            label: "Face Sunscreen",
            value: "face-sunscreen",
            id: generateMongoId(),
          },
          { label: "Body Spray", value: "body-spray", id: generateMongoId() },
        ],
      },
      {
        label: "After Sun",
        value: "after-sun",
        id: generateMongoId(),
        childCategories: [
          {
            label: "Soothing Gel",
            value: "soothing-gel",
            id: generateMongoId(),
          },
          { label: "Moisturizer", value: "moisturizer", id: generateMongoId() },
          { label: "Repair Balm", value: "repair-balm", id: generateMongoId() },
        ],
      },
      {
        label: "Tanning Products",
        value: "tanning-products",
        id: generateMongoId(),
        childCategories: [
          { label: "Self-Tanner", value: "self-tanner", id: generateMongoId() },
          { label: "Tanning Oil", value: "tanning-oil", id: generateMongoId() },
          { label: "Bronzer", value: "bronzer", id: generateMongoId() },
        ],
      },
    ],
  },
  {
    label: "Beauty Supplements",
    value: "beauty-supplements",
    id: generateMongoId(),
    subCategories: [
      {
        label: "Vitamins",
        value: "vitamins",
        id: generateMongoId(),
        childCategories: [
          { label: "Vitamin C", value: "vitamin-c", id: generateMongoId() },
          { label: "Biotin", value: "biotin", id: generateMongoId() },
          { label: "Collagen", value: "collagen", id: generateMongoId() },
          { label: "Omega-3", value: "omega-3", id: generateMongoId() },
        ],
      },
      {
        label: "Minerals",
        value: "minerals",
        id: generateMongoId(),
        childCategories: [
          { label: "Zinc", value: "zinc", id: generateMongoId() },
          { label: "Magnesium", value: "magnesium", id: generateMongoId() },
          { label: "Iron", value: "iron", id: generateMongoId() },
        ],
      },
      {
        label: "Herbal Supplements",
        value: "herbal-supplements",
        id: generateMongoId(),
        childCategories: [
          { label: "Ginseng", value: "ginseng", id: generateMongoId() },
          { label: "Turmeric", value: "turmeric", id: generateMongoId() },
          {
            label: "Green Tea Extract",
            value: "green-tea-extract",
            id: generateMongoId(),
          },
        ],
      },
    ],
  },
  {
    label: "Treatments",
    value: "treatments",
    id: generateMongoId(),
    subCategories: [
      {
        label: "Skin Treatments",
        value: "skin-treatments",
        id: generateMongoId(),
        childCategories: [
          {
            label: "Acne Treatment",
            value: "acne-treatment",
            id: generateMongoId(),
          },
          {
            label: "Hyperpigmentation",
            value: "hyperpigmentation",
            id: generateMongoId(),
          },
          {
            label: "Scar Removal",
            value: "scar-removal",
            id: generateMongoId(),
          },
          {
            label: "Anti-Wrinkle",
            value: "anti-wrinkle",
            id: generateMongoId(),
          },
        ],
      },
      {
        label: "Hair Treatments",
        value: "hair-treatments",
        id: generateMongoId(),
        childCategories: [
          { label: "Hair Loss", value: "hair-loss", id: generateMongoId() },
          {
            label: "Dandruff Control",
            value: "dandruff-control",
            id: generateMongoId(),
          },
          { label: "Hair Growth", value: "hair-growth", id: generateMongoId() },
        ],
      },
      {
        label: "Body Treatments",
        value: "body-treatments",
        id: generateMongoId(),
        childCategories: [
          {
            label: "Cellulite Cream",
            value: "cellulite-cream",
            id: generateMongoId(),
          },
          {
            label: "Stretch Mark Cream",
            value: "stretch-mark-cream",
            id: generateMongoId(),
          },
          { label: "Body Scrub", value: "body-scrub", id: generateMongoId() },
        ],
      },
    ],
  },
  {
    label: "Natural & Organic",
    value: "natural-organic",
    id: generateMongoId(),
    subCategories: [
      {
        label: "Face Care",
        value: "face-care",
        id: generateMongoId(),
        childCategories: [
          {
            label: "Organic Cleanser",
            value: "organic-cleanser",
            id: generateMongoId(),
          },
          {
            label: "Natural Moisturizer",
            value: "natural-moisturizer",
            id: generateMongoId(),
          },
          { label: "Face Oil", value: "face-oil", id: generateMongoId() },
          { label: "Mask", value: "mask", id: generateMongoId() },
        ],
      },
      {
        label: "Body Care",
        value: "body-care",
        id: generateMongoId(),
        childCategories: [
          {
            label: "Organic Lotion",
            value: "organic-lotion",
            id: generateMongoId(),
          },
          { label: "Body Butter", value: "body-butter", id: generateMongoId() },
          {
            label: "Natural Soap",
            value: "natural-soap",
            id: generateMongoId(),
          },
        ],
      },
      {
        label: "Hair Care",
        value: "hair-care",
        id: generateMongoId(),
        childCategories: [
          {
            label: "Organic Shampoo",
            value: "organic-shampoo",
            id: generateMongoId(),
          },
          {
            label: "Natural Conditioner",
            value: "natural-conditioner",
            id: generateMongoId(),
          },
          { label: "Hair Oil", value: "hair-oil", id: generateMongoId() },
        ],
      },
    ],
  },
  {
    label: "Makeup",
    value: "makeup",
    id: generateMongoId(),
    subCategories: [
      {
        label: "Face Makeup",
        value: "face-makeup",
        id: generateMongoId(),
        childCategories: [
          { label: "Foundation", value: "foundation", id: generateMongoId() },
          { label: "Concealer", value: "concealer", id: generateMongoId() },
          { label: "Blush", value: "blush", id: generateMongoId() },
          { label: "Powder", value: "powder", id: generateMongoId() },
        ],
      },
      {
        label: "Eye Makeup",
        value: "eye-makeup",
        id: generateMongoId(),
        childCategories: [
          { label: "Eyeshadow", value: "eyeshadow", id: generateMongoId() },
          { label: "Eyeliner", value: "eyeliner", id: generateMongoId() },
          { label: "Mascara", value: "mascara", id: generateMongoId() },
        ],
      },
      {
        label: "Lip Products",
        value: "lip-products",
        id: generateMongoId(),
        childCategories: [
          { label: "Lipstick", value: "lipstick", id: generateMongoId() },
          { label: "Lip Gloss", value: "lip-gloss", id: generateMongoId() },
          { label: "Lip Balm", value: "lip-balm", id: generateMongoId() },
        ],
      },
    ],
  },
  {
    label: "Korean Beauty",
    value: "korean-beauty",
    id: generateMongoId(),
    subCategories: [
      {
        label: "Skincare",
        value: "korean-skincare",
        id: generateMongoId(),
        childCategories: [
          { label: "Sheet Masks", value: "sheet-masks", id: generateMongoId() },
          { label: "Essence", value: "essence", id: generateMongoId() },
          {
            label: "Cushion Foundation",
            value: "cushion-foundation",
            id: generateMongoId(),
          },
          { label: "Toner", value: "toner", id: generateMongoId() },
        ],
      },
      {
        label: "Hair Care",
        value: "korean-hair-care",
        id: generateMongoId(),
        childCategories: [
          {
            label: "Hair Treatment",
            value: "hair-treatment",
            id: generateMongoId(),
          },
          { label: "Scalp Care", value: "scalp-care", id: generateMongoId() },
          { label: "Hair Serum", value: "hair-serum", id: generateMongoId() },
        ],
      },
      {
        label: "Body Care",
        value: "korean-body-care",
        id: generateMongoId(),
        childCategories: [
          { label: "Body Lotion", value: "body-lotion", id: generateMongoId() },
          { label: "Hand Cream", value: "hand-cream", id: generateMongoId() },
          { label: "Foot Mask", value: "foot-mask", id: generateMongoId() },
        ],
      },
    ],
  },
];

export const allHealthPackages = [
  {
    name: "Life Platinum Package",
    salePrice: 100,
    regularPrice: 120,
    tests: [
      "Blood Test",
      "Liver Function Test",
      "Thyroid Function Test",
      "Cholesterol Test",
      "Blood Sugar Test",
      "Blood Pressure Test",
    ],
  },
  {
    name: "Life Gold Package",
    salePrice: 100,
    regularPrice: 120,
    tests: [
      "Blood Test",
      "Liver Function Test",
      "Thyroid Function Test",
      "Cholesterol Test",
      "Blood Sugar Test",
      "Blood Pressure Test",
    ],
  },
  {
    name: "Harmones Wellness Package",
    salePrice: 100,
    regularPrice: 120,
    tests: [
      "Blood Test",
      "Liver Function Test",
      "Thyroid Function Test",
      "Cholesterol Test",
      "Blood Sugar Test",
      "Blood Pressure Test",
    ],
  },
  {
    name: "Life Elite Women's Package",
    salePrice: 100,
    regularPrice: 120,
    tests: [
      "Blood Test",
      "Liver Function Test",
      "Thyroid Function Test",
      "Cholesterol Test",
      "Blood Sugar Test",
      "Blood Pressure Test",
    ],
  },
  {
    name: "Life Wow Package",
    salePrice: 100,
    regularPrice: 120,
    tests: [
      "Blood Test",
      "Liver Function Test",
      "Thyroid Function Test",
      "Cholesterol Test",
      "Blood Sugar Test",
      "Blood Pressure Test",
    ],
  },
  {
    name: "Harmones Wellness Men's Package",
    salePrice: 100,
    regularPrice: 120,
    tests: [
      "Blood Test",
      "Liver Function Test",
      "Thyroid Function Test",
      "Cholesterol Test",
      "Blood Sugar Test",
      "Blood Pressure Test",
    ],
  },
];

export const dummyDescription =
  "Organix is a brand that sells natural and organic products for skin, hair, and body care. It is a brand that is known for its high-quality products and its commitm to sustainability. Organix is a brand that is known for its high-quality products and its commitment to sustainability. Organix is a brand that is known for its high-quality products and its commitment to sustainability. Organix is a brand that is known for its high-quality products and its commitment to sustainability. Organix is a brand that is known for its high-quality products and its commitment to sustainability. Organix is a brand that is known for its high-quality products and its commitment to sustainability. Organix is a brand that is known for its high-quality products and its commitment to sustainability.";

export const DummyHomecareProducts = [
  {
    _id: "6847d1123024c29435c29dd3",
    serviceName: "Blood Pressure Check",
    shortDescription:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.",
    prescriptionRequired: true,
    price: 4000,
    isLiked: false,
    mainImage: "/uploads/HomeCareService/image-1749537041768-58407431.PNG",
  },
  {
    _id: "6847d1123024c29435c29dd3",
    serviceName: "Blood Pressure Check",
    shortDescription:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.",
    prescriptionRequired: true,
    price: 4000,
    isLiked: false,
    mainImage: "/uploads/HomeCareService/image-1749537041768-58407431.PNG",
  },
  {
    _id: "6847d1123024c29435c29dd3",
    serviceName: "Blood Pressure Check",
    shortDescription:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.",
    prescriptionRequired: true,
    price: 4000,
    isLiked: false,
    mainImage: "/uploads/HomeCareService/image-1749537041768-58407431.PNG",
  },
  {
    _id: "6847d1123024c29435c29dd3",
    serviceName: "Blood Pressure Check",
    shortDescription:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.",
    prescriptionRequired: true,
    price: 4000,
    isLiked: false,
    mainImage: "/uploads/HomeCareService/image-1749537041768-58407431.PNG",
  },
  {
    _id: "6847d1123024c29435c29dd3",
    serviceName: "Blood Pressure Check",
    shortDescription:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.",
    prescriptionRequired: true,
    price: 4000,
    isLiked: false,
    mainImage: "/uploads/HomeCareService/image-1749537041768-58407431.PNG",
  },
  {
    _id: "6847d1123024c29435c29dd3",
    serviceName: "Blood Pressure Check",
    shortDescription:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.",
    prescriptionRequired: true,
    price: 4000,
    isLiked: false,
    mainImage: "/uploads/HomeCareService/image-1749537041768-58407431.PNG",
  },
  {
    _id: "6847d1123024c29435c29dd3",
    serviceName: "Blood Pressure Check",
    shortDescription:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.",
    prescriptionRequired: true,
    price: 4000,
    isLiked: false,
    mainImage: "/uploads/HomeCareService/image-1749537041768-58407431.PNG",
  },
];

export let docotrProfiledata = [
  {
    _id: "67a1bd627a781234d91f74b4",
    servicesDetails: [
      {
        _id: "66e00e6ca5ab2f3db69572ff",
        name: "Fracture treatment",
        __v: 0,
        createdAt: "2024-09-10T09:16:28.521Z",
        updatedAt: "2024-09-10T09:16:28.521Z",
      },
    ],
    diseasesDetails: [
      {
        _id: "66dfde254f11b5d3251c069c",
        name: "Hepatitis A",
        diseasesImage:
          "/uploads/diseases/diseasesImage-1737003686296-709352764.png",
        createdAt: "2024-09-10T05:50:29.714Z",
        updatedAt: "2025-01-16T05:01:26.458Z",
        __v: 0,
      },
    ],
    specailizedDetails: [
      {
        _id: "66e01829a5ab2f3db6957342",
        name: "Gastroentrologist",
        SpecailImage:
          "/uploads/speical/SpecailImage-1737003526644-949554864.png",
        createdAt: "2024-09-10T09:58:01.861Z",
        updatedAt: "2025-01-16T04:58:46.804Z",
        __v: 0,
      },
    ],
    aboutMe: "I am a doctor willing to serve mankind",
    contact: "23678436292",
    education: [
      {
        institution: "ABC medical college",
        course: "MBBS",
        startDate: "2016-01-01T00:00:00.000Z",
        endDate: "2020-01-01T00:00:00.000Z",
        _id: "67b715dec757d9c65e63dda7",
      },
    ],
    email: "patrickwallwork@yopmail.com",
    address: {
      city: "ajman",
      address:
        "Office 118, Emirates City, Sheikh Mohammed Bin Zayed Road, Ajman, UAE.",
    },
    socailLinks: {
      facebookLink: "",
      linkedinLink: "",
      instagramLink: "",
      whatsappLink: "",
    },
    experiences: [
      {
        role: "Cardiologist",
        hospitalName: "XYZ",
        startDate: "2019-01-20T00:00:00.000Z",
        endDate: "2025-01-20T00:00:00.000Z",
        _id: "67b7166ac757d9c65e63df3e",
      },
      {
        role: "Cardiologist",
        hospitalName: "abc hospital",
        startDate: "2020-01-20T00:00:00.000Z",
        endDate: "2025-02-20T00:00:00.000Z",
        _id: "67b715abc757d9c65e63dd08",
      },
    ],
    availability: {
      monday: [["12:00", "14:00"]],
      wednesday: [["12:00", "15:00"]],
      fees: "250",
      _id: "67a2fb044c2f17989f5a48a1",
    },
    timings: [
      {
        hospitalName: "ABC Hospital",
        fees: "100",
        monday: [["12:00", "14:00"]],
        _id: "67a2f9be4c2f17989f5a42ec",
        createdAt: "2025-02-05T05:40:14.077Z",
        updatedAt: "2025-02-05T05:40:14.077Z",
      },
    ],
    educatuonHistory: ["MBBS"],
    workExperienceMonthly: "73",
    coverPhoto: "/uploads/profile/image-1740051757940-403902233.png",
    backgroundPicture: null,
    firstName: "Patrick ",
    lastName: "Wallwork",
    gender: "male",
    dateofBirth: "1989-02-19T00:00:00.000Z",
    userVerified: "verified",
    createdAt: "2025-02-04T07:10:26.827Z",
    reviewStar: null,
    reviews: null,
  },
];

export const DummyText = `
<p className=" flex items-start font-Lexend-Regular font-size-18px text-[#707070]">
              Rossmax HS200 Blood Sugar Test Strips can eliminate interference
              from oxygen variations and non-glucose sugar such as maltose and
              galactose, providing you with the most reliable and accurate
              results. They provide full warranty and is suitable for self
              testing. Each strip can be used ONCE ONLY!. A test strip consists
              of the following parts: Target Area: Where a blood drop or control
              solution is touched. Confirmation Window: To confirm if sufficient
              blood drop or control solution has been applied to Target Area.
              Contact Bar: The end of the test strip is to be inserted into the
              test port (top side facing up). On each test strip the target area
              contains reaction chemicals. When blood is applied to this area, a
              chemical reaction takes place, then a transient electrical current
              is formed. The blood glucose concentration is calculated based on
              the electrical current detected by the meter, then the result is
              showed on the display. The test measures glucose from 20 mg/dL
              (1.1mmol/L) to 600 mg/dL (33.3mmol/L). The Rossmax HS200 Test
              Strip is calibrated to display the equivalent of plasma glucose
              values to allow easy comparison of results with laboratory
              methods.
            </p>
`;

export const DummyReviewRating = {
  success: true,
  message: "success",
  totalReviews: 5,
  averageRating: 3.5,
  recommendPercentage: 70,
  ratingBreakdown: {
    one: 0,
    two: 1,
    three: 0,
    four: 0,
    five: 1,
  },
};

export const dummyReviews = {
  success: true,
  message: "success",
  documents: [
    {
      _id: "67af23aab13554cdef8433e3",
      message: "Poor Service",
      rating: 2,
      firstName: "Cody ",
      lastName: "Brake",
      coverPhoto: "/uploads/profile/image-1739334887774-734056608.png",
    },
    {
      _id: "6847ba78d1ca7149264ac1cf",
      message: "good",
      rating: 5,
      firstName: "James",
      lastName: "Avenue",
      coverPhoto: "/uploads/profile/image-1748333397427-871147372.png",
    },
    {
      _id: "6847ba78d1ca7149264dc1cf",
      message: "good",
      rating: 5,
      firstName: "James",
      lastName: "Avenue",
      coverPhoto: "/uploads/profile/image-1748333397427-871147372.png",
    },
  ],
  paginated: {
    currentPage: 1,
    totalPages: 1,
    limit: 2,
    totalItems: 2,
  },
};

export const dummySalesData = {
  diagnosticOrders: {
    yearlyData: [
      {
        _id: {
          year: 2025,
        },
        totalAmount: 539760.16,
      },
    ],
    monthlyData: [
      {
        _id: {
          year: 2025,
          month: 1,
        },
        totalAmount: 25674,
      },
      {
        _id: {
          year: 2025,
          month: 2,
        },
        totalAmount: 80887.59,
      },
      {
        _id: {
          year: 2025,
          month: 3,
        },
        totalAmount: 700,
      },
      {
        _id: {
          year: 2025,
          month: 4,
        },
        totalAmount: 15430.01,
      },
      {
        _id: {
          year: 2025,
          month: 5,
        },
        totalAmount: 75604.55,
      },
      {
        _id: {
          year: 2025,
          month: 6,
        },
        totalAmount: 177187.51,
      },
      {
        _id: {
          year: 2025,
          month: 7,
        },
        totalAmount: 11651.5,
      },
      {
        _id: {
          year: 2025,
          month: 9,
        },
        totalAmount: 152625,
      },
    ],
    totalSale: [
      {
        totalAmount: 359691.64,
      },
    ],
  },
  pharmaOrders: {
    yearlyData: [
      {
        _id: {
          year: 2025,
        },
        totalAmount: 1091202.33,
      },
    ],
    monthlyData: [
      {
        _id: {
          year: 2025,
          month: 1,
        },
        totalAmount: 9372.59,
      },
      {
        _id: {
          year: 2025,
          month: 2,
        },
        totalAmount: 39987.47,
      },
      {
        _id: {
          year: 2025,
          month: 4,
        },
        totalAmount: 2031.58,
      },
      {
        _id: {
          year: 2025,
          month: 5,
        },
        totalAmount: 38827.130000000005,
      },
      {
        _id: {
          year: 2025,
          month: 6,
        },
        totalAmount: 133285.56,
      },
      {
        _id: {
          year: 2025,
          month: 7,
        },
        totalAmount: 8120,
      },
      {
        _id: {
          year: 2025,
          month: 8,
        },
        totalAmount: 38078,
      },
      {
        _id: {
          year: 2025,
          month: 9,
        },
        totalAmount: 821500,
      },
    ],
    totalSale: [
      {
        totalAmount: 1015037.26,
      },
    ],
  },
  homeCareServices: {
    yearlyData: [
      {
        _id: {
          year: 2025,
        },
        totalAmount: 134242.5,
      },
    ],
    monthlyData: [
      {
        _id: {
          year: 2025,
          month: 1,
        },
        totalAmount: 9013.5,
      },
      {
        _id: {
          year: 2025,
          month: 2,
        },
        totalAmount: 36365,
      },
      {
        _id: {
          year: 2025,
          month: 5,
        },
        totalAmount: 54875,
      },
      {
        _id: {
          year: 2025,
          month: 6,
        },
        totalAmount: 3149,
      },
      {
        _id: {
          year: 2025,
          month: 8,
        },
        totalAmount: 6380,
      },
      {
        _id: {
          year: 2025,
          month: 9,
        },
        totalAmount: 24460,
      },
    ],
    totalSale: [
      {
        totalAmount: 71882,
      },
    ],
  },
  consultations: {
    yearlyData: [
      {
        _id: {
          year: 2024,
        },
        totalAmount: 109675,
      },
      {
        _id: {
          year: 2025,
        },
        totalAmount: 26663171,
      },
    ],
    monthlyData: [
      {
        _id: {
          year: 2025,
          month: 1,
        },
        totalAmount: 11737,
      },
      {
        _id: {
          year: 2025,
          month: 2,
        },
        totalAmount: 13994,
      },
      {
        _id: {
          year: 2025,
          month: 3,
        },
        totalAmount: 2100,
      },
      {
        _id: {
          year: 2025,
          month: 4,
        },
        totalAmount: 4500,
      },
      {
        _id: {
          year: 2025,
          month: 5,
        },
        totalAmount: 34338,
      },
      {
        _id: {
          year: 2025,
          month: 6,
        },
        totalAmount: 26160895,
      },
      {
        _id: {
          year: 2025,
          month: 8,
        },
        totalAmount: 41123,
      },
      {
        _id: {
          year: 2025,
          month: 9,
        },
        totalAmount: 394484,
      },
    ],
    totalSale: [
      {
        totalAmount: 7559630,
      },
    ],
  },
};

export const DummyReviewsData = [
  {
    _id: "68e497cc0f8fb85be042e666",
    longConsultation: "30 mins",
    doctorConsultation: "1 hour",
    diagnosis: "yes",
    like: "10",
    comment: ":)))))))))))))))))))",
    createdAt: "2025-10-07T04:32:12.907Z",
    updatedAt: "2025-10-07T04:44:28.590Z",
    customerFirstName: "JamesT",
    customerlastName: "Weiss Andrew Json",
    customerProfileImageUrl:
      "https://ndisync-stage.s3.us-east-1.amazonaws.com/shifara-storage/multerOptionsProfile-1759398153721-385479055.png",
  },
  {
    _id: "68e497850f8fb85be042e4f4",
    longConsultation: "15 mins",
    doctorConsultation: "20 mins",
    diagnosis: "yes",
    like: "4",
    comment: "gooooooooooooooood",
    createdAt: "2025-10-07T04:31:01.745Z",
    updatedAt: "2025-10-07T04:31:01.745Z",
    customerFirstName: "Roy",
    customerlastName: "Martin Weiss Andrew Json Weiss Andrew Json",
    customerProfileImageUrl: "",
  },
  {
    _id: "68e497160f8fb85be042e2eb",
    longConsultation: "30 mins",
    doctorConsultation: "10 mins",
    diagnosis: "no",
    like: "4",
    comment: "nice service",
    createdAt: "2025-10-07T04:29:10.271Z",
    updatedAt: "2025-10-07T04:29:10.271Z",
    customerFirstName: "Michael",
    customerlastName: "Weems",
    customerProfileImageUrl:
      "https://ndisync-stage.s3.us-east-1.amazonaws.com/shifara-storage/multerOptionsProfile-1759558893291-388808886.png",
  },
  {
    _id: "68e35bd9118933cef695d31c",
    longConsultation: "",
    doctorConsultation: "",
    diagnosis: "",
    like: "0",
    comment: "",
    createdAt: "2025-10-06T06:04:09.200Z",
    updatedAt: "2025-10-06T06:04:09.200Z",
    customerFirstName: "Linda",
    customerlastName: "Dizon",
    customerProfileImageUrl:
      "https://ndisync-stage.s3.us-east-1.amazonaws.com/shifara-storage/multerOptionsProfile-1759386508409-112942218.PNG",
  },
  {
    _id: "68e35bc2118933cef695d2cf",
    longConsultation: "less then 10 Mins",
    doctorConsultation: "5 mins",
    diagnosis: "yes",
    like: "5",
    comment:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut a",
    createdAt: "2025-10-06T06:03:46.909Z",
    updatedAt: "2025-10-06T06:13:20.076Z",
    customerFirstName: "Linda",
    customerlastName: "Dizon",
    customerProfileImageUrl:
      "https://ndisync-stage.s3.us-east-1.amazonaws.com/shifara-storage/multerOptionsProfile-1759386508409-112942218.PNG",
  },
  {
    _id: "68e35b9e118933cef695d162",
    longConsultation: "15 mins",
    doctorConsultation: "10 mins",
    diagnosis: "yes",
    like: "5",
    comment: "testing1",
    createdAt: "2025-10-06T06:03:10.810Z",
    updatedAt: "2025-10-06T06:03:10.810Z",
    customerFirstName: "Linda",
    customerlastName: "Dizon",
    customerProfileImageUrl:
      "https://ndisync-stage.s3.us-east-1.amazonaws.com/shifara-storage/multerOptionsProfile-1759386508409-112942218.PNG",
  },
  {
    _id: "68e35b84118933cef695d129",
    longConsultation: "less then 10 Mins",
    doctorConsultation: "5 mins",
    diagnosis: "",
    like: "5",
    comment: "demodemo",
    createdAt: "2025-10-06T06:02:44.998Z",
    updatedAt: "2025-10-06T06:02:44.998Z",
    customerFirstName: "Linda",
    customerlastName: "Dizon",
    customerProfileImageUrl:
      "https://ndisync-stage.s3.us-east-1.amazonaws.com/shifara-storage/multerOptionsProfile-1759386508409-112942218.PNG",
  },
];
